/**
 * Grant del operador de caja (``X-POS-Operator-Token``).
 *
 * Todo escritor POS del backend (pagos, asientos manuales, cafetería,
 * mutaciones de citas, oficialización) exige el token emitido al identificar
 * al operador por PIN (``activarOperadorPOS``). Sin token el servidor responde
 * 403, así que los servicios fallan localmente ANTES de llamar: la UI debe
 * bloquear la acción hasta que exista un operador identificado.
 */
export const OPERATOR_TOKEN_HEADER = 'X-POS-Operator-Token';

export const OPERATOR_GRANT_REQUIRED = 'Identifica al operador de caja con su PIN antes de continuar.';

export const requireOperatorToken = (token: string | null | undefined): string => {
    if (typeof token !== 'string' || token.trim() === '') {
        throw new Error(OPERATOR_GRANT_REQUIRED);
    }
    return token;
};

export const operatorHeaders = (token: string, extra: Record<string, string> = {}) => ({
    headers: { ...extra, [OPERATOR_TOKEN_HEADER]: token },
});
